import { forwardRef, Text } from '@chakra-ui/react';

/**
 * @type React.ForwardRefRenderFunction<any, import('@chakra-ui/react').TextProps>
 * @param {import('@chakra-ui/react').TextProps} props */
const MenuText = forwardRef((props, ref) => {
    return (
        <Text color={'#EDF2F7'} fontSize="md" ref={ref} {...props}>
            {props.children}
        </Text>
    );
});

export default MenuText;
